/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_Remove_SavedInputs */

const en_directory_card_remove_saved = /** @type {(inputs: Directory_Card_Remove_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove saved product`)
};

const zh_directory_card_remove_saved = /** @type {(inputs: Directory_Card_Remove_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消收藏`)
};

/**
* | output |
* | --- |
* | "Remove saved product" |
*
* @param {Directory_Card_Remove_SavedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_remove_saved = /** @type {((inputs?: Directory_Card_Remove_SavedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Remove_SavedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_remove_saved(inputs)
	return zh_directory_card_remove_saved(inputs)
});
export { directory_card_remove_saved as "directory.card.remove_saved" }